import { render, staticRenderFns } from "./AppHeaderHomeButton.vue?vue&type=template&id=0c3e0584&scoped=true&"
import script from "./AppHeaderHomeButton.vue?vue&type=script&lang=ts&"
export * from "./AppHeaderHomeButton.vue?vue&type=script&lang=ts&"
import style0 from "./AppHeaderHomeButton.vue?vue&type=style&index=0&id=0c3e0584&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3e0584",
  null
  
)

export default component.exports